import { render, staticRenderFns } from "./ProductBalance.vue?vue&type=template&id=2b7435f8&scoped=true&"
import script from "./ProductBalance.vue?vue&type=script&lang=js&"
export * from "./ProductBalance.vue?vue&type=script&lang=js&"
import style0 from "./ProductBalance.vue?vue&type=style&index=0&id=2b7435f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7435f8",
  null
  
)

export default component.exports